/** 어드민 공용 표기 — 한국어 로케일, 24시간제 */
export const toMessage = (err: unknown) => (err instanceof Error ? err.message : String(err))

export const fmtTime = (iso: string | null | undefined) =>
  iso
    ? new Date(iso).toLocaleString('ko-KR', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    : '—'

export const fmtDate = (iso: string | null | undefined) =>
  iso
    ? new Date(iso).toLocaleDateString('ko-KR', { year: 'numeric', month: 'short', day: 'numeric' })
    : '—'

export const fmtMoney = (n: number, currency: string) =>
  new Intl.NumberFormat(currency === 'KRW' ? 'ko-KR' : 'en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: currency === 'KRW' ? 0 : 2,
  }).format(n)

export const fmtUsd = (n: number, digits = 2) =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`

export const fmtInt = (n: number) => n.toLocaleString('ko-KR')
